/* eslint-disable jsx-a11y/control-has-associated-label */
import { COUNTRY_OPTIONS, STATE_OPTIONS } from 'components/global/_helpers/global.consts';
import ProfileImageUpload from 'components/global/ProfileImageUpload';
import UniversalInput from 'components/global/UniversalInput';
import { handleCompanyLogoRemove, handleCompanyLogoUpload, handleSubmitCompanyEdit } from 'components/views/FounderSettings/_helpers/founderSettings.events';
import { fetchAndSetCompanySettingsData } from 'components/views/FounderSettings/_helpers/founderSettings.resolvers';
import { Button, Col, Row } from 'react-bootstrap';
import { $form, $view, $user } from 'signals/global.signals';
import useEffectAsync from 'utils/useEffectAsync';

const Company = () => {
  useEffectAsync(fetchAndSetCompanySettingsData);
  return (
    <Row className="mt-24">
      <Col>
        <Row className="mb-32">
          <Col xs={12}>
            <div className="d-flex flex-column align-items-center mb-24">
              <h5 className="mb-16">Company Logo</h5>
              <ProfileImageUpload
                entityId={$user.value.organization.id}
                currentImage={$form.value.logoImage}
                defaultName={$form.value.name}
                avatarColors={$form.value.logoColors}
                onImageUpload={handleCompanyLogoUpload}
                onImageRemove={handleCompanyLogoRemove}
                uploadPath="organization-assets"
                className="orgAvatarImage"
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col lg={6} className="mb-24">
            <UniversalInput
              name="name"
              label="Company Name"
              required
            />
          </Col>
          <Col lg={6} className="mb-24">
            <UniversalInput
              name="email"
              label="Company Email"
              required
            />
          </Col>
          <Col lg={6} className="mb-24">
            <UniversalInput
              name="phone"
              label="Company Phone"
              required
            />
          </Col>
          <Col lg={6} className="mb-24">
            <UniversalInput
              name="website"
              label="Company Website"
              required
            />
          </Col>
          <Col lg={6} className="mb-24">
            <UniversalInput
              name="street"
              label="Street Address"
              required
            />
          </Col>
          <Col lg={6} className="mb-24">
            <UniversalInput
              name="city"
              label="City"
              required
            />
          </Col>
          <Col lg={6} className="mb-24">
            <UniversalInput
              type="select"
              name="provinceCode"
              options={STATE_OPTIONS}
              label="State/Province"
              required
            />
          </Col>
          <Col lg={6} className="mb-24">
            <UniversalInput
              type="zip"
              name="zip"
              label="Zip Code"
              required
            />
          </Col>
          <Col lg={6} className="mb-24">
            <UniversalInput
              type="select"
              options={COUNTRY_OPTIONS}
              name="countryCode"
              label="Country"
              className="mb-24"
              required
            />
          </Col>
          <Col lg={12} className="d-flex align-items-center">
            <Button
              className="fw-500 px-16 py-4 my-8 px-md-56 px-32"
              onClick={handleSubmitCompanyEdit}
              disabled={$view.value.isLoading}
            >
              {$view.value.isLoading ? 'Saving...' : 'Save'}
            </Button>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default Company;
